/* USDS Reviews page (sections/usds-reviews-hub.liquid).
   Data: window.USDS_REVIEWS (assets/usds-reviews-data.js, rebuilt by tools/refresh_reviews.py),
   topped up with the newest reviews from Judge.me's public feed when "Live refresh" is on.
   Customer types, product types and experiences are derived here from review text, product tags
   and titles, so newly fetched reviews are classified the same way as the snapshot. */
(function () {
  'use strict';
  function init() {
  var root = document.querySelector('[data-urh]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var cfgEl = root.querySelector('[data-urh-config]');
  var CFG = cfgEl ? JSON.parse(cfgEl.textContent) : {};
  var DATA = window.USDS_REVIEWS || { products: {}, reviews: [], fields: [] };
  var PAGE = CFG.pageSize || 12;

  /* ── Taxonomy ─────────────────────────────────────────────── */
  var CUSTOMER = [
    { id: 'first-time', label: 'First-time pilots', short: 'First-time pilot',
      rx: /\b(first (real |ever |actual )?drone|first time (flying|drone|pilot|flyer)|new to (drones|flying|fpv)|beginner|never flown|newbie|novice|learning to fly)\b/i },
    { id: 'public-safety', label: 'Public safety', short: 'Public safety',
      rx: /\b(sheriff|police|law enforcement|fire ?(dept|department|fighters?|rescue)|first responders?|search (and|&) rescue|\bsar\b|county|municipal(ity|ities)?|swat|emergency management|public safety|deputies|city of)\b/i },
    { id: 'land', label: 'Ag, land & hunting', short: 'Ag & land',
      rx: /\b(farm(s|ing|er)?|ranch(ing|er)?|hunt(ing|er|ers)?|deer|hogs?|wildlife|livestock|cattle|acres?|crops?|game recovery|orchard|timber)\b/i },
    { id: 'commercial', label: 'Commercial operators', short: 'Commercial',
      rx: /\b(my (business|company)|our (business|company|team|department|fleet|agency)|fleet|clients?|contracts?|inspections?|survey(s|ing)?|mapping|roofs?|roofing|real estate|part 107|commercial|drone services|backbone|for work|job ?sites?|construction|utilit(y|ies)|enterprise|operators?)\b/i },
    { id: 'creator', label: 'Creators & hobbyists', short: 'Creator / hobbyist',
      rx: /\b(photos|pictures|photography|video(s|graphy)?|filming|footage|cinematic|content|youtube|travel(ing)?|trip|vacation|hobby|hobbyist|for fun|fun to fly|fpv build|custom build|scenery|sunsets?|landscapes?|creator|aerial (shots|photos)|selfies?)\b/i },
    { id: 'gift', label: 'Gift buyers', short: 'Gift buyer',
      rx: /\b(gift|present for|christmas|xmas|birthday|for my (husband|wife|son|daughter|grandson|granddaughter|dad|father|kids?))\b/i },
    { id: 'returning', label: 'Returning customers', short: 'Returning customer',
      rx: /\b(second (order|purchase|time|drone)|third (order|purchase|time)|ordered (again|before)|another order|previous(ly)? (order|purchase|bought)|repeat customer|go[- ]to (vendor|source|supplier|place|shop|store)|(will|would|i'?ll) (definitely |certainly |surely )?(be )?(buy|order|purchas|shop|do business)\w* (from (them|you|here|us drone supply|usds) |with (them|you) )?again|again from|(buy|order|shop)\w* from (them|you|here) again|future (orders?|purchases?))\b/i }
  ];

  var EXPERIENCE = [
    { id: 'shipping', label: 'Shipping & delivery', desc: 'Arrival time & tracking',
      pos: /\b(ship|deliver|arriv|turn ?around|tracking|came (quick|fast|early|in)|got (it|here) (fast|quick|early))/i,
      neg: /\b(delay(ed|s)?|took (too |so )?long|took (a while|forever|weeks)|late delivery|arrived late|still waiting|been waiting|backorder(ed)?|extra week|weeks to (arrive|ship)|didn'?t (get|arrive) (it )?(on time|overnight)|lost (in transit|package))\b/i },
    { id: 'support', label: 'Customer support', desc: 'Help before & after the sale',
      pos: /\b(customer (service|support)|service|staff|support|helpful|responsive|respon(ded|se)|answer(ed|s)?|communicat(ion|ive|ed)|kept (me|us) (updated|informed|posted)|knowledgeable|followed up|reached out|the (guys|team|folks|people)|accommodating|above and beyond|went above)\b|\b(Max|Matt)\b/i,
      neg: /\b(no (response|reply)|never (heard|responded|replied|got back)|rude|unhelpful|ignored|poor (service|communication)|no communication|had to (contact|call|email) (them )?(a few|several|multiple) times)\b/i },
    { id: 'authentic', label: 'Genuine & as described', desc: 'Sealed, legit, US stock',
      pos: /\b(genuine|legit(imate)?|authentic|sealed|brand new|\boem\b|real deal|as described|as advertised|exactly (as|what)|not a scam|trust(ed|worthy)?|original (box|packaging)|real product|us[- ]based|in the us)\b/i,
      neg: /\b(not new|used (one|unit|item)|opened box|resealed|tampered|not as described|wrong (item|model)|counterfeit|fake)\b/i },
    { id: 'availability', label: 'Hard-to-find stock', desc: 'In stock when others weren\'t',
      pos: /\b(in stock|hard to (get|find|come by)|out of stock (everywhere|elsewhere)|no ?one (else )?(has|had)|nobody (else )?(has|had)|couldn'?t find|availability|lead time|not (officially )?(sell|available) in the us|dji ban|ban\b|able to (get|obtain|find))\b/i,
      neg: /(?!)/ },
    { id: 'value', label: 'Price & value', desc: 'Fair pricing, worth it',
      pos: /\b(great price|good price|best price|fair price|competitive|pric(e|ing) (was|were|is) (great|good|fair|right|competitive)|value|worth (every|it|the)|good deal|great deal|affordable|discount|cheaper)\b/i,
      neg: /\b(too (much|expensive|pricey)|overpriced|paid (way )?too much|price gouging|markup)\b/i },
    { id: 'packaging', label: 'Packaging & condition', desc: 'Arrived safe & secure',
      pos: /\b(well[- ]?(packaged|packed|boxed|wrapped|shipped)|packag(ed|ing) (was )?(great|well|nicely|secure)|plenty of (foam|padding)|perfect condition|great (shape|condition)|good condition|excellent condition|no (visual )?damage|not a scratch|securely (packed|packaged)|solid packaging|secure package)\b/i,
      neg: /\b(damaged|torn|dented|crushed|broken (box|seal)|box was (damaged|beat))\b/i },
    { id: 'performance', label: 'Flight & camera performance', desc: 'How the gear performs',
      pos: /\b(flight time|flies (great|well|amazing|beautiful)|joy to fly|flying|camera|image quality|picture quality|footage|thermal|zoom|stable|gimbal|range|battery life|brightness|performance|obstacle|signal|video quality|resolution|sharp|crisp|powerful)\b/i,
      neg: /\b(doesn'?t work|does not work|not work(ing)?|stopped working|defective|defect|dead on arrival|\bdoa\b|won'?t (charge|connect|turn on|pair|register)|failed|disappoint(ed|ing)|not as (quiet|good|bright)|less than (advertised|expected))\b/i },
    { id: 'setup', label: 'Easy setup', desc: 'Pairing, activation, first flight',
      pos: /\b(easy to (set ?up|use|fly|install|pair|operate)|set ?up was (easy|simple|quick)|easy set ?up|pair(ed|s)? (easily|quickly|right up|with)|plug and play|up and (flying|running)|out of the box|user[- ]friendly|intuitive|simple to (use|set ?up))\b/i,
      neg: /\b(hard to (set ?up|pair|activate)|couldn'?t (pair|activate|register)|activation (issue|problem)|wouldn'?t (pair|activate|register))\b/i },
    { id: 'resolution', label: 'Problem solved', desc: 'Issues handled & made right',
      pos: /\b(resolv(ed|e)|fixed (it|the issue)|made (it|things) right|took care of|claim|solution|sorted (it )?out|replaced (it|the)|quick response and solution|update my review|exchange)\b/i,
      neg: /\b(no refunds?|won'?t refund|refused|denied|still (not|haven'?t) (resolved|heard))\b/i }
  ];

  var PRODUCT_TYPES = [
    { id: 'consumer', label: 'Consumer drones' },
    { id: 'enterprise', label: 'Enterprise drones' },
    { id: 'fpv', label: 'FPV drones' },
    { id: 'payload', label: 'Payloads & enterprise add-ons' },
    { id: 'power', label: 'Batteries & charging' },
    { id: 'control', label: 'Controllers & goggles' },
    { id: 'parts', label: 'Parts & accessories' },
    { id: 'camera', label: 'Cameras' },
    { id: 'care', label: 'USDS Care' }
  ];

  function productType(handle, title, tags) {
    var t = (title || '').toLowerCase();
    var tg = (tags || []).map(function (x) { return String(x).toLowerCase(); });
    var has = function (k) { return tg.indexOf(k) > -1; };
    if (handle === 'us-cared' || /usds care/.test(t)) return 'care';
    if (/battery|charging hub|charger|power adapter|power bank/.test(t) || has('battery')) return 'power';
    if (/remote controller|\brc\b|goggles|motion controller/.test(t) || has('remote') || has('goggles')) return 'control';
    if (/propeller|prop guard|guard|lens kit|filter|bag|case|strap|landing pad|transmission module|air unit/.test(t)) return 'parts';
    if (has('drone') && (has('enterprise') || /matrice|mavic 3t|mavic 3e|agras/.test(t))) return 'enterprise';
    if (has('drone') && (has('fpv') || /avata|fpv/.test(t))) return 'fpv';
    if (has('drone') || / drone\b|mini \d|air 3|neo 2|mavic 4/.test(t)) return 'consumer';
    if (/spotlight|speaker|manifold|zenmuse|lidar|monitor|payload|dock/.test(t) || has('4t') || has('4td') || has('4e')) return 'payload';
    if (/osmo|action \d|pocket|camera|insta360/.test(t) || has('camera')) return 'camera';
    return 'parts';
  }

  /* ── Normalise rows ───────────────────────────────────────── */
  var F = {};
  (DATA.fields || []).forEach(function (f, i) { F[f] = i; });
  var byId = {};
  var reviews = [];
  // Review IDs hidden from the page (section setting "Hidden reviews"), also blocks live re-adds
  var HIDDEN = {};
  String(CFG.hidden || '').split(/[\s,]+/).forEach(function (h) { if (h) HIDDEN[h.trim()] = 1; });

  function addRow(row) {
    var id = row[F.id];
    if (!id || byId[id] || HIDDEN[id]) return;
    var handle = row[F.handle] || '';
    var p = DATA.products[handle] || null;
    var title = (p && p[0]) || row[F.product] || '';
    var body = row[F.body] || '';
    var text = (row[F.title] || '') + ' \n' + body;
    var r = {
      id: id,
      rating: +row[F.rating] || 5,
      date: row[F.date] || '',
      handle: handle,
      product: title,
      img: (p && p[1]) || '',
      author: row[F.author] || 'Verified pilot',
      verified: !!row[F.verified],
      title: row[F.title] || '',
      body: body,
      pics: row[F.pics] || [],
      vids: row[F.vids] || [],
      location: row[F.location] || '',
      reply: (F.reply != null && row[F.reply]) || ''
    };
    r.ptype = productType(handle, title, p && p[2]);
    r.ctypes = CUSTOMER.filter(function (c) { return c.rx.test(text); }).map(function (c) { return c.id; });
    if (!r.ctypes.some(function (c) { return c !== 'returning'; }) && (r.ptype === 'enterprise' || r.ptype === 'payload')) r.ctypes.push('commercial');
    r.exp = {};
    EXPERIENCE.forEach(function (e) {
      var neg = e.neg.test(text);
      if (neg || e.pos.test(text)) r.exp[e.id] = neg ? -1 : 1;
    });
    r.words = body.trim().split(/\s+/).filter(Boolean).length;
    r.hay = (title + ' ' + r.author + ' ' + text).toLowerCase();
    r.score = r.pics.length * 40 + r.vids.length * 60 + Math.min(r.words, 120) + (r.title ? 6 : 0) + (r.rating - 3) * 4;
    byId[id] = r;
    reviews.push(r);
  }
  (DATA.reviews || []).forEach(addRow);

  /* ── State ────────────────────────────────────────────────── */
  var state = { ct: [], pt: [], ex: [], rating: [], photos: false, q: '', sort: 'featured', shown: PAGE, wall: CFG.wallCount || 16 };
  var GROUPS = {
    ct: { label: CFG.labels.customer, items: CUSTOMER },
    pt: { label: CFG.labels.product, items: PRODUCT_TYPES },
    ex: { label: CFG.labels.experience, items: EXPERIENCE },
    rating: { label: CFG.labels.rating, items: [5, 4, 3, 2, 1].map(function (n) { return { id: String(n), label: n + ' star' + (n > 1 ? 's' : '') }; }) }
  };

  function readUrl() {
    var u = new URLSearchParams(location.search);
    ['ct', 'pt', 'ex', 'rating'].forEach(function (k) { if (u.get(k)) state[k] = u.get(k).split(',').filter(Boolean); });
    if (u.get('photos') === '1') state.photos = true;
    if (u.get('q')) state.q = u.get('q');
    if (u.get('sort')) state.sort = u.get('sort');
  }
  function writeUrl() {
    var u = new URLSearchParams(location.search);
    ['ct', 'pt', 'ex', 'rating'].forEach(function (k) { state[k].length ? u.set(k, state[k].join(',')) : u.delete(k); });
    state.photos ? u.set('photos', '1') : u.delete('photos');
    state.q ? u.set('q', state.q) : u.delete('q');
    state.sort !== 'featured' ? u.set('sort', state.sort) : u.delete('sort');
    var s = u.toString();
    history.replaceState(null, '', location.pathname + (s ? '?' + s : '') + location.hash);
  }

  function matches(r, skip) {
    if (skip !== 'ct' && state.ct.length && !state.ct.some(function (c) { return r.ctypes.indexOf(c) > -1; })) return false;
    if (skip !== 'pt' && state.pt.length && state.pt.indexOf(r.ptype) < 0) return false;
    if (skip !== 'ex' && state.ex.length && !state.ex.some(function (e) { return r.exp[e]; })) return false;
    if (skip !== 'rating' && state.rating.length && state.rating.indexOf(String(r.rating)) < 0) return false;
    if (state.photos && !r.pics.length && !r.vids.length) return false;
    if (state.q && r.hay.indexOf(state.q.toLowerCase()) < 0) return false;
    return true;
  }
  function filtered() {
    var list = reviews.filter(function (r) { return matches(r); });
    var s = state.sort;
    list.sort(function (a, b) {
      if (s === 'featured') return b.score - a.score || (b.date > a.date ? 1 : -1);
      if (s === 'high') return b.rating - a.rating || (b.date > a.date ? 1 : -1);
      if (s === 'low') return a.rating - b.rating || (b.date > a.date ? 1 : -1);
      return b.date > a.date ? 1 : b.date < a.date ? -1 : 0;
    });
    return list;
  }

  /* ── Helpers ──────────────────────────────────────────────── */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function $(sel) { return root.querySelector(sel); }
  function avg(list) { if (!list.length) return 0; return list.reduce(function (s, r) { return s + r.rating; }, 0) / list.length; }
  function fmt1(n) { return (Math.round(n * 10) / 10).toFixed(1); }
  function pct(n, d) { return d ? Math.round(n / d * 100) : 0; }
  function pic(u, w) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'quality=80&width=' + w : ''; }
  function shopImg(u, w) { return u ? u.replace(/(\?v=\d+)?$/, function (m) { return (m ? m + '&' : '?') + 'width=' + w; }) : ''; }
  function stars(r, dk) { return '<span class="urh-stars' + (dk ? ' urh-stars--dk' : '') + '" style="--r:' + r + '" role="img" aria-label="' + fmt1(r) + ' out of 5 stars"></span>'; }
  function month(d) { var p = d.split('-'); return new Date(+p[0], +p[1] - 1, +(p[2] || 1)).toLocaleDateString(undefined, { month: 'short', year: 'numeric' }); }
  function label(group, id) { var it = GROUPS[group].items.filter(function (i) { return i.id === id; })[0]; return it ? it.label : id; }
  var ICON = {
    chev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>',
    cam: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"/><circle cx="12" cy="13" r="3"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 5l7 7-7 7"/></svg>'
  };

  function bestQuote(list) {
    var c = list.filter(function (r) { return r.rating >= 5 && r.words >= 14 && r.words <= 48; })
      .sort(function (a, b) { return b.score - a.score; })[0];
    if (!c) c = list.slice().sort(function (a, b) { return b.score - a.score; })[0];
    return c;
  }
  // Best-scoring photo in the list, skipping any already used elsewhere on the page
  function firstPhoto(list, used) {
    var best = null;
    list.filter(function (x) { return x.pics.length; }).sort(function (a, b) { return b.score - a.score; })
      .some(function (r) { return r.pics.some(function (p) { if (used && used[p]) return false; best = { src: p, id: r.id }; return true; }); });
    if (best && used) used[best.src] = 1;
    return best;
  }
  function productImg(list) {
    var counts = {};
    list.forEach(function (r) { if (r.img) counts[r.img] = (counts[r.img] || 0) + 1; });
    return Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; })[0] || '';
  }
  function topExp(list, n) {
    return EXPERIENCE.map(function (e) {
      return { e: e, n: list.filter(function (r) { return r.exp[e.id] === 1; }).length };
    }).filter(function (x) { return x.n; }).sort(function (a, b) { return b.n - a.n; }).slice(0, n);
  }

  var heroPics = {};
  /* ── Hero ─────────────────────────────────────────────────── */
  function renderHero() {
    var n = reviews.length, a = avg(reviews);
    var photos = reviews.reduce(function (s, r) { return s + r.pics.length; }, 0);
    var five = reviews.filter(function (r) { return r.rating === 5; }).length;
    var prods = {}; reviews.forEach(function (r) { prods[r.handle || r.product] = 1; });
    var ship = reviews.filter(function (r) { return r.exp.shipping === 1; }).length;
    var written = reviews.filter(function (r) { return r.words >= 4; }).length;

    var big = $('[data-hero-score]');
    if (big) big.innerHTML =
      '<div><div class="urh-score-big urh-num">' + fmt1(a) + '</div>' + stars(a, true) +
      '<div class="urh-score-meta urh-num">' + n.toLocaleString() + ' ' + esc(CFG.labels.reviews) + '</div></div>' +
      '<div class="urh-dist">' + [5, 4, 3, 2, 1].map(function (s) {
        var c = reviews.filter(function (r) { return r.rating === s; }).length;
        return '<button type="button" class="urh-dist-row" data-rate-jump="' + s + '" aria-label="Show ' + c + ' ' + s + '-star reviews">' +
          '<span class="urh-num">' + s + '★</span><span class="urh-dist-bar"><i style="width:' + pct(c, n) + '%"></i></span><span class="urh-num">' + c + '</span></button>';
      }).join('') + '</div>';

    var chips = $('[data-hero-chips]');
    if (chips) chips.innerHTML = [
      [pct(five, n) + '%', CFG.labels.chipFive],
      [photos, CFG.labels.chipPhotos],
      [Object.keys(prods).length, CFG.labels.chipProducts],
      [pct(ship, written) + '%', CFG.labels.chipShip]
    ].map(function (c) { return '<span class="urh-chip-stat"><b class="urh-num">' + esc(c[0]) + '</b>' + esc(c[1]) + '</span>'; }).join('');

    var h1 = $('[data-hero-count]');
    if (h1) h1.textContent = n.toLocaleString();

    var mosaic = $('[data-hero-mosaic]');
    if (mosaic) {
      var seen = {}, tiles = [];
      reviews.filter(function (r) { return r.pics.length && r.rating >= 4; })
        .sort(function (a, b) { return b.score - a.score; })
        .forEach(function (r) { if (tiles.length < 8 && !seen[r.handle]) { seen[r.handle] = 1; tiles.push(r); } });
      reviews.filter(function (r) { return r.pics.length && tiles.indexOf(r) < 0; }).forEach(function (r) { if (tiles.length < 8) tiles.push(r); });
      heroPics = {};
      tiles.forEach(function (r) { heroPics[r.pics[0]] = 1; });
      mosaic.innerHTML = tiles.map(function (r, i) {
        var more = i === tiles.length - 1 && photos > tiles.length ? '<span class="urh-mosaic-more">+' + (photos - tiles.length) + ' ' + esc(CFG.labels.photos) + '</span>' : '';
        return '<button type="button" data-lb-review="' + esc(r.id) + '" data-lb-i="0" aria-label="' + esc('Photo from ' + r.author + ', ' + r.product) + '">' +
          '<img src="' + pic(r.pics[0], i === 0 ? 900 : 480) + '" alt="" loading="' + (i < 4 ? 'eager' : 'lazy') + '">' +
          '<span class="urh-mosaic-cap">' + esc(r.product) + '</span>' + more + '</button>';
      }).join('');
    }
  }

  /* ── Patterns ─────────────────────────────────────────────── */
  function renderPatterns() {
    var written = reviews.filter(function (r) { return r.words >= 4; });
    var W = written.length;

    var themes = $('[data-themes]');
    if (themes) {
      var rows = EXPERIENCE.map(function (e) {
        var pos = written.filter(function (r) { return r.exp[e.id] === 1; }).length;
        var neg = written.filter(function (r) { return r.exp[e.id] === -1; }).length;
        return { e: e, pos: pos, neg: neg, tot: pos + neg };
      }).filter(function (x) { return x.tot; }).sort(function (a, b) { return b.tot - a.tot; });
      var max = rows.length ? rows[0].tot : 1;
      themes.innerHTML = rows.map(function (x) {
        var on = state.ex.indexOf(x.e.id) > -1;
        return '<button type="button" class="urh-theme' + (on ? ' is-on' : '') + '" data-jump="ex" data-id="' + x.e.id + '" aria-pressed="' + on + '"' +
          ' aria-label="' + esc(x.e.label + ': mentioned in ' + pct(x.tot, W) + '% of written reviews, ' + pct(x.pos, x.tot) + '% positive. Show these reviews.') + '">' +
          '<span class="urh-theme-name">' + esc(x.e.label) + '<small>' + pct(x.pos, x.tot) + '% positive · ' + x.tot + ' mentions</small></span>' +
          '<span class="urh-theme-bar" style="width:' + Math.max(6, x.tot / max * 100) + '%">' +
          '<i style="flex:' + x.pos + '"></i>' + (x.neg ? '<i class="neg" style="flex:' + x.neg + '"></i>' : '') + '</span></button>';
      }).join('');
    }

    var trend = $('[data-trend]');
    if (trend) {
      var months = {};
      reviews.forEach(function (r) { var k = r.date.slice(0, 7); if (k) (months[k] = months[k] || []).push(r); });
      var keys = Object.keys(months).sort().slice(-14);
      var mx = Math.max.apply(null, keys.map(function (k) { return months[k].length; }).concat([1]));
      trend.innerHTML = keys.map(function (k) {
        var l = months[k];
        return '<div class="urh-trend-col" tabindex="0" aria-label="' + esc(month(k + '-01') + ': ' + l.length + ' reviews, ' + fmt1(avg(l)) + ' average') + '">' +
          '<i style="height:' + Math.max(2, l.length / mx * 100) + '%"></i><span class="urh-tip"><b>' + esc(month(k + '-01')) + '</b><br>' + l.length + ' reviews · ' + fmt1(avg(l)) + '★</span></div>';
      }).join('');
      var ax = $('[data-trend-axis]');
      if (ax && keys.length) ax.innerHTML = '<span>' + esc(month(keys[0] + '-01')) + '</span><span>' + esc(month(keys[keys.length - 1] + '-01')) + '</span>';
    }

    var seg = $('[data-segments]');
    if (seg) {
      var usedPics = Object.assign({}, heroPics);
      seg.innerHTML = CUSTOMER.map(function (c) {
        var l = reviews.filter(function (r) { return r.ctypes.indexOf(c.id) > -1; });
        if (!l.length || l.length < (CFG.segMin || 1)) return '';
        var q = bestQuote(l), ph = firstPhoto(l, usedPics), te = topExp(l, 2), on = state.ct.indexOf(c.id) > -1;
        var media = ph ? '<img src="' + pic(ph.src, 600) + '" alt="" loading="lazy">' :
          (productImg(l) ? '<img src="' + shopImg(productImg(l), 500) + '" alt="" loading="lazy" style="object-fit:contain;padding:14px;background:#fff">' : '');
        return '<button type="button" class="urh-seg' + (on ? ' is-on' : '') + '" data-jump="ct" data-id="' + c.id + '" aria-pressed="' + on + '">' +
          '<span class="urh-seg-media">' + media + '<span>' + esc(c.short) + '</span></span>' +
          '<span class="urh-seg-body"><span class="urh-seg-top"><span class="urh-seg-name">' + esc(c.label) + '</span><span class="urh-seg-count urh-num">' + l.length + ' reviews</span></span>' +
          '<span class="urh-seg-rate">' + stars(avg(l)) + '<span class="urh-num">' + fmt1(avg(l)) + '</span></span>' +
          (q ? '<span class="urh-seg-q">“' + esc(q.body.length > 170 ? q.body.slice(0, 165).replace(/\s+\S*$/, '') + '…' : q.body) + '”</span>' : '') +
          '<span class="urh-seg-tags">' + te.map(function (x) { return '<span class="urh-tag">' + esc(x.e.label) + '</span>'; }).join('') + '</span></span></button>';
      }).join('');
    }

    var pt = $('[data-ptypes]');
    if (pt) {
      pt.innerHTML = PRODUCT_TYPES.map(function (t) {
        var l = reviews.filter(function (r) { return r.ptype === t.id; });
        if (!l.length) return '';
        var ph = firstPhoto(l), on = state.pt.indexOf(t.id) > -1;
        var withImg = l.filter(function (r) { return r.img; });
        var counts = {}; withImg.forEach(function (r) { counts[r.img] = (counts[r.img] || 0) + 1; });
        var topImg = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; })[0];
        var img = ph ? '<img src="' + pic(ph.src, 160) + '" alt="" loading="lazy">' : (topImg ? '<img class="is-prod" src="' + shopImg(topImg, 160) + '" alt="" loading="lazy">' : '<img alt="">');
        return '<button type="button" class="urh-pt' + (on ? ' is-on' : '') + '" data-jump="pt" data-id="' + t.id + '" aria-pressed="' + on + '">' + img +
          '<span><b>' + esc(t.label) + '</b><small>' + stars(avg(l)) + '<span class="urh-num">' + fmt1(avg(l)) + ' · ' + l.length + '</span></small></span></button>';
      }).join('');
    }
  }

  /* ── Media wall ───────────────────────────────────────────── */
  function renderWall(list) {
    var wall = $('[data-wall]');
    if (!wall) return;
    var items = [];
    list.forEach(function (r) { r.pics.forEach(function (p, i) { items.push({ r: r, i: i, src: p }); }); });
    items.sort(function (a, b) { return b.r.score - a.r.score || (b.r.date > a.r.date ? 1 : -1); });
    var cnt = $('[data-wall-count]');
    if (cnt) cnt.textContent = items.length;
    if (!items.length) {
      wall.innerHTML = '<div class="urh-empty">' + esc(CFG.labels.noPhotos) + '</div>';
      wall.style.columns = 'auto';
    } else {
      wall.style.columns = '';
      wall.innerHTML = items.slice(0, state.wall).map(function (x) {
        return '<button type="button" class="urh-wall-item" data-lb-review="' + esc(x.r.id) + '" data-lb-i="' + x.i + '" aria-label="' + esc('Open photo from ' + x.r.author + ' about ' + x.r.product) + '">' +
          '<img src="' + pic(x.src, 520) + '" alt="' + esc('Customer photo: ' + x.r.product) + '" loading="lazy">' +
          '<span class="urh-wall-cap"><b>' + esc(x.r.product) + '</b>' + stars(x.r.rating, true) + '</span></button>';
      }).join('');
    }
    var more = $('[data-wall-more]');
    if (more) more.hidden = items.length <= state.wall;
  }

  /* ── Filter bar ───────────────────────────────────────────── */
  function renderBar() {
    ['ct', 'pt', 'ex', 'rating'].forEach(function (g) {
      var dd = root.querySelector('[data-dd="' + g + '"]');
      if (!dd) return;
      var base = reviews.filter(function (r) { return matches(r, g); });
      var sel = state[g];
      var btn = dd.querySelector('.urh-dd-btn');
      btn.classList.toggle('has-val', sel.length > 0);
      btn.innerHTML = esc(GROUPS[g].label) + (sel.length ? '<em>' + sel.length + '</em>' : '') + ICON.chev;
      dd.querySelector('.urh-dd-menu').innerHTML = GROUPS[g].items.map(function (it) {
        var n = base.filter(function (r) {
          if (g === 'ct') return r.ctypes.indexOf(it.id) > -1;
          if (g === 'pt') return r.ptype === it.id;
          if (g === 'ex') return !!r.exp[it.id];
          return String(r.rating) === it.id;
        }).length;
        var on = sel.indexOf(it.id) > -1;
        if (!n && !on) return '';
        return '<button type="button" class="urh-opt" role="menuitemcheckbox" aria-checked="' + on + '" data-opt="' + g + '" data-id="' + esc(it.id) + '">' +
          '<span class="urh-opt-box"></span><span class="urh-opt-name">' + esc(it.label) + '</span><span class="urh-opt-n">' + n + '</span></button>';
      }).join('');
    });
    var ph = $('[data-photos]');
    if (ph) ph.setAttribute('aria-pressed', state.photos);
    var srt = $('[data-sort]');
    if (srt) srt.value = state.sort;
    var se = $('[data-search]');
    if (se && se.value !== state.q) se.value = state.q;

    var act = $('[data-active]');
    if (act) {
      var pills = [];
      ['ct', 'pt', 'ex', 'rating'].forEach(function (g) {
        state[g].forEach(function (id) { pills.push('<button type="button" class="urh-pill" data-rm="' + g + '" data-id="' + esc(id) + '">' + esc(label(g, id)) + '<span aria-hidden="true">×</span><b hidden>Remove</b></button>'); });
      });
      if (state.photos) pills.push('<button type="button" class="urh-pill" data-rm="photos">' + esc(CFG.labels.withPhotos) + '<span aria-hidden="true">×</span></button>');
      if (state.q) pills.push('<button type="button" class="urh-pill" data-rm="q">“' + esc(state.q) + '”<span aria-hidden="true">×</span></button>');
      if (pills.length > 1) pills.push('<button type="button" class="urh-link" data-clear>' + esc(CFG.labels.clear) + '</button>');
      act.innerHTML = pills.join('');
    }
  }

  /* ── Review cards ─────────────────────────────────────────── */
  function highlight(text) {
    var h = esc(text);
    if (state.q && state.q.length > 1) {
      var q = state.q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      h = h.replace(new RegExp('(' + esc(q) + ')', 'ig'), '<mark>$1</mark>');
    }
    return h;
  }
  // USDS's public reply, shown on reviews at or below the configured rating
  function replyBlock(r) {
    if (!r.reply || r.rating > (CFG.replyMax || 4)) return '';
    return '<div class="urh-rv-reply"><span class="urh-rv-reply-h"><span class="urh-rv-reply-logo" aria-hidden="true">US</span>' + esc(CFG.labels.replyFrom) + '</span>' +
      '<p>' + esc(r.reply) + '</p></div>';
  }
  function card(r) {
    var media = '';
    if (r.vids.length) {
      media = '<div class="urh-rv-media urh-rv-media--1"><video src="' + esc(r.vids[0]) + '" controls playsinline preload="metadata"></video></div>';
    } else if (r.pics.length) {
      var shown = Math.min(3, r.pics.length);
      media = '<div class="urh-rv-media urh-rv-media--' + shown + '">' + r.pics.slice(0, 3).map(function (p, i) {
        var extra = i === 2 && r.pics.length > 3 ? '<span class="urh-rv-more">+' + (r.pics.length - 3) + '</span>' : '';
        return '<button type="button" data-lb-review="' + esc(r.id) + '" data-lb-i="' + i + '" aria-label="' + esc('Open photo ' + (i + 1) + ' of ' + r.pics.length + ' from ' + r.author) + '">' +
          '<img src="' + pic(p, shown === 1 || i === 0 ? 720 : 360) + '" alt="' + esc('Customer photo of ' + r.product) + '" loading="lazy">' + extra + '</button>';
      }).join('') + '</div>';
    }
    var tags = EXPERIENCE.filter(function (e) { return r.exp[e.id]; }).slice(0, 3).map(function (e) {
      return '<span class="urh-tag' + (r.exp[e.id] < 0 ? ' urh-tag--neg' : '') + '">' + esc(e.label) + '</span>';
    }).concat(r.ctypes.slice(0, 1).map(function (c) {
      return '<span class="urh-tag urh-tag--plain">' + esc(CUSTOMER.filter(function (x) { return x.id === c; })[0].short) + '</span>';
    })).join('');
    var long = r.body.length > 340;
    var prodUrl = r.handle ? (CFG.root || '/') + 'products/' + r.handle : '';
    return '<article class="urh-rv">' + media +
      '<div class="urh-rv-body"><div class="urh-rv-top">' + stars(r.rating) + (r.date ? '<time datetime="' + esc(r.date) + '">' + esc(month(r.date)) + '</time>' : '') + '</div>' +
      (r.title ? '<h3 class="urh-rv-t">' + highlight(r.title) + '</h3>' : '') +
      (r.body ? '<p class="urh-rv-q' + (long ? ' is-clamped' : '') + '">' + highlight(r.body) + '</p>' : '') +
      (long ? '<button type="button" class="urh-link" data-readmore aria-expanded="false">' + esc(CFG.labels.readMore) + '</button>' : '') +
      (tags ? '<div class="urh-rv-tags">' + tags + '</div>' : '') +
      replyBlock(r) +
      '<div class="urh-rv-by"><span class="urh-rv-av" aria-hidden="true">' + esc(r.author.charAt(0)) + '</span><span><strong>' + esc(r.author) + '</strong><small>' +
      (r.verified ? '<span class="urh-rv-ver">' + ICON.check + esc(CFG.labels.verified) + '</span>' : '') +
      (r.location ? (r.verified ? ' · ' : '') + esc(r.location) : '') + '</small></span></div>' +
      (window.Shopify && Shopify.designMode ? '<small class="urh-rv-id" title="Paste into Hidden reviews to hide this review">ID: ' + esc(r.id) + '</small>' : '') + '</div>' +
      (prodUrl ? '<a class="urh-rv-prod" href="' + esc(prodUrl) + '">' + (r.img ? '<img src="' + shopImg(r.img, 80) + '" alt="" loading="lazy">' : '') +
        '<span><small>' + esc(CFG.labels.reviewOf) + '</small><b>' + esc(r.product) + '</b></span>' + ICON.arrow + '</a>' : '') +
      '</article>';
  }

  function renderList() {
    var list = filtered();
    var grid = $('[data-grid]');
    var cnt = $('[data-count]');
    if (cnt) cnt.innerHTML = '<b class="urh-num">' + list.length.toLocaleString() + '</b> ' + esc(list.length === 1 ? CFG.labels.review : CFG.labels.reviews) +
      (list.length !== reviews.length ? ' of ' + reviews.length.toLocaleString() : '');
    var sum = $('[data-sum]');
    if (sum) sum.innerHTML = list.length ? stars(avg(list)) + '<span class="urh-num">' + fmt1(avg(list)) + ' avg</span>' : '';
    if (grid) grid.innerHTML = list.length ? list.slice(0, state.shown).map(card).join('') :
      '<div class="urh-empty" style="column-span:all">' + esc(CFG.labels.noMatch) + ' <button type="button" class="urh-link" data-clear>' + esc(CFG.labels.clear) + '</button></div>';
    var more = $('[data-more]');
    if (more) {
      more.hidden = list.length <= state.shown;
      more.textContent = CFG.labels.showMore + ' (' + (list.length - state.shown) + ')';
    }
    var foot = $('[data-foot-note]');
    if (foot) foot.textContent = Math.min(state.shown, list.length) + ' / ' + list.length;
    renderWall(list);
  }

  function renderAll(keepPage) {
    if (!keepPage) { state.shown = PAGE; state.wall = CFG.wallCount || 16; }
    renderBar();
    renderList();
    root.querySelectorAll('[data-jump]').forEach(function (b) {
      var on = state[b.dataset.jump].indexOf(b.dataset.id) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on);
    });
    writeUrl();
  }

  /* ── Lightbox ─────────────────────────────────────────────── */
  var lb = null, lbList = [], lbPos = 0, lastFocus = null;
  function lbItems() {
    var items = [];
    filtered().forEach(function (r) { r.pics.forEach(function (p, i) { items.push({ r: r, i: i }); }); });
    return items;
  }
  function openLb(id, i) {
    lbList = lbItems();
    lbPos = lbList.findIndex(function (x) { return x.r.id === id && x.i === i; });
    if (lbPos < 0) {
      var r = byId[id];
      if (!r) return;
      lbList = r.pics.map(function (p, k) { return { r: r, i: k }; });
      lbPos = i;
    }
    lastFocus = document.activeElement;
    if (!lb) {
      lb = document.createElement('div');
      lb.className = 'urh-lb';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.setAttribute('aria-label', CFG.labels.photoViewer);
      lb.innerHTML = '<div class="urh-lb-stage"><img alt=""><button type="button" class="urh-lb-x" aria-label="Close">✕</button>' +
        '<button type="button" class="urh-lb-nav urh-lb-prev" aria-label="Previous photo">←</button><button type="button" class="urh-lb-nav urh-lb-next" aria-label="Next photo">→</button>' +
        '<span class="urh-lb-count"></span></div><div class="urh-lb-side"></div>';
      root.appendChild(lb);
      lb.addEventListener('click', function (e) {
        if (e.target.closest('.urh-lb-x') || e.target === lb.querySelector('.urh-lb-stage')) return closeLb();
        if (e.target.closest('.urh-lb-prev')) return stepLb(-1);
        if (e.target.closest('.urh-lb-next')) return stepLb(1);
        var t = e.target.closest('[data-lb-jump]');
        if (t) { var k = lbList.findIndex(function (x) { return x.r.id === t.dataset.lbJump && x.i === +t.dataset.i; }); if (k > -1) { lbPos = k; drawLb(); } }
      });
      var sx = null;
      lb.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function (e) { if (sx == null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) stepLb(dx < 0 ? 1 : -1); sx = null; });
    }
    lb.hidden = false;
    document.documentElement.classList.add('urh-lock');
    drawLb();
    lb.querySelector('.urh-lb-x').focus();
  }
  function drawLb() {
    var x = lbList[lbPos]; if (!x) return;
    var r = x.r, img = lb.querySelector('.urh-lb-stage img');
    // Show the size the page already loaded, then swap in full resolution once it arrives
    var full = pic(r.pics[x.i], 1600), token = full;
    img.dataset.want = token;
    img.src = pic(r.pics[x.i], 720);
    var hi = new Image();
    hi.onload = function () { if (img.dataset.want === token) img.src = full; };
    hi.src = full;
    img.alt = 'Customer photo of ' + r.product + ' from ' + r.author;
    lb.querySelector('.urh-lb-count').textContent = (lbPos + 1) + ' / ' + lbList.length;
    lb.querySelectorAll('.urh-lb-nav').forEach(function (b) { b.hidden = lbList.length < 2; });
    var prodUrl = r.handle ? (CFG.root || '/') + 'products/' + r.handle : '';
    lb.querySelector('.urh-lb-side').innerHTML =
      (prodUrl ? '<a class="urh-rv-prod" style="border:1px solid var(--bdr);border-radius:12px;margin:0 0 4px" href="' + esc(prodUrl) + '">' + (r.img ? '<img src="' + shopImg(r.img, 80) + '" alt="">' : '') +
        '<span><small>' + esc(CFG.labels.reviewOf) + '</small><b>' + esc(r.product) + '</b></span>' + ICON.arrow + '</a>' : '') +
      '<div class="urh-rv-top">' + stars(r.rating) + (r.date ? '<time>' + esc(month(r.date)) + '</time>' : '') + '</div>' +
      (r.title ? '<h3 class="urh-rv-t">' + esc(r.title) + '</h3>' : '') +
      (r.body ? '<p class="urh-rv-q">' + esc(r.body) + '</p>' : '') +
      replyBlock(r) +
      '<div class="urh-rv-by"><span class="urh-rv-av" aria-hidden="true">' + esc(r.author.charAt(0)) + '</span><span><strong>' + esc(r.author) + '</strong><small>' +
      (r.verified ? '<span class="urh-rv-ver">' + ICON.check + esc(CFG.labels.verified) + '</span>' : '') + '</small></span></div>' +
      (r.pics.length > 1 ? '<div class="urh-lb-thumbs">' + r.pics.map(function (p, k) {
        return '<button type="button" data-lb-jump="' + esc(r.id) + '" data-i="' + k + '" aria-label="Photo ' + (k + 1) + '"' + (k === x.i ? ' aria-current="true"' : '') + '><img src="' + pic(p, 120) + '" alt=""></button>';
      }).join('') + '</div>' : '');
    var nx = lbList[lbPos + 1];
    if (nx) { var pre = new Image(); pre.src = pic(nx.r.pics[nx.i], 720); }
  }
  function stepLb(d) { lbPos = (lbPos + d + lbList.length) % lbList.length; drawLb(); }
  function closeLb() {
    if (!lb) return;
    lb.hidden = true;
    document.documentElement.classList.remove('urh-lock');
    if (lastFocus) lastFocus.focus();
  }

  /* ── Events ───────────────────────────────────────────────── */
  function toggle(arr, v) { var i = arr.indexOf(v); i > -1 ? arr.splice(i, 1) : arr.push(v); }
  function closeMenus(except) {
    root.querySelectorAll('[data-dd].is-open').forEach(function (d) {
      if (d !== except) { d.classList.remove('is-open'); d.querySelector('.urh-dd-menu').hidden = true; d.querySelector('.urh-dd-btn').setAttribute('aria-expanded', 'false'); }
    });
  }
  function toExplorer() {
    var ex = $('#urh-explore') || $('[data-explore]');
    if (ex) ex.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  root.addEventListener('click', function (e) {
    var t;
    // Tap on the mobile sheet backdrop (the dropdown's ::before) closes it
    if (e.target.matches('[data-dd]')) { closeMenus(); return; }
    if ((t = e.target.closest('[data-lb-review]'))) { openLb(t.dataset.lbReview, +t.dataset.lbI || 0); return; }
    if ((t = e.target.closest('.urh-dd-btn'))) {
      var dd = t.closest('[data-dd]'), open = !dd.classList.contains('is-open');
      closeMenus(dd);
      dd.classList.toggle('is-open', open);
      dd.querySelector('.urh-dd-menu').hidden = !open;
      t.setAttribute('aria-expanded', open);
      return;
    }
    if ((t = e.target.closest('[data-opt]'))) { toggle(state[t.dataset.opt], t.dataset.id); renderAll(); var d2 = t.closest('[data-dd]'); if (d2) { d2.classList.add('is-open'); d2.querySelector('.urh-dd-menu').hidden = false; } return; }
    if ((t = e.target.closest('[data-jump]'))) {
      var g = t.dataset.jump;
      toggle(state[g], t.dataset.id);
      renderAll(); toExplorer(); return;
    }
    if ((t = e.target.closest('[data-rate-jump]'))) { state.rating = t.dataset.rateJump.split(','); if (state.rating.length > 1) state.sort = 'low'; renderAll(); toExplorer(); return; }
    if ((t = e.target.closest('[data-rm]'))) {
      var k = t.dataset.rm;
      if (k === 'photos') state.photos = false; else if (k === 'q') state.q = ''; else toggle(state[k], t.dataset.id);
      renderAll(); return;
    }
    if (e.target.closest('[data-clear]')) { state.ct = []; state.pt = []; state.ex = []; state.rating = []; state.photos = false; state.q = ''; renderAll(); return; }
    if (e.target.closest('[data-photos]')) { state.photos = !state.photos; renderAll(); return; }
    if (e.target.closest('[data-more]')) { state.shown += PAGE; renderAll(true); return; }
    if (e.target.closest('[data-wall-more]')) { state.wall += CFG.wallCount || 16; renderWall(filtered()); return; }
    if ((t = e.target.closest('[data-readmore]'))) {
      var q = t.previousElementSibling, ex = q.classList.toggle('is-clamped');
      t.textContent = ex ? CFG.labels.readMore : CFG.labels.readLess;
      t.setAttribute('aria-expanded', !ex);
      return;
    }
  });
  document.addEventListener('click', function (e) { if (!e.target.closest('[data-dd]')) closeMenus(); });
  document.addEventListener('keydown', function (e) {
    if (lb && !lb.hidden) {
      if (e.key === 'Escape') closeLb();
      else if (e.key === 'ArrowRight') stepLb(1);
      else if (e.key === 'ArrowLeft') stepLb(-1);
      else if (e.key === 'Tab') {
        var f = lb.querySelectorAll('button:not([hidden]), a[href]');
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    } else if (e.key === 'Escape') closeMenus();
  });
  var se = $('[data-search]'), st;
  if (se) se.addEventListener('input', function () { clearTimeout(st); st = setTimeout(function () { state.q = se.value.trim(); renderAll(); }, 220); });
  var srt = $('[data-sort]');
  if (srt) srt.addEventListener('change', function () { state.sort = srt.value; renderAll(); });

  /* Keep the filter bar below a sticky theme header */
  function stickyOffset() {
    var h = document.querySelector('.shopify-section-group-header-group, sticky-header, .section-header, header.header');
    var off = 0;
    if (h) { var cs = getComputedStyle(h); if (cs.position === 'sticky' || cs.position === 'fixed') off = h.getBoundingClientRect().height; }
    root.style.setProperty('--urh-sticky', Math.max(0, Math.round(off)) + 'px');
  }

  /* ── Live top-up from Judge.me ────────────────────────────── */
  // Judge.me HTML → plain text: paragraphs become blank lines, <br> becomes a line break
  function paras(node) {
    if (!node) return '';
    node.querySelectorAll('br').forEach(function (b) { b.replaceWith('\n'); });
    var ps = node.querySelectorAll('p');
    var parts = ps.length ? Array.prototype.map.call(ps, function (p) { return p.textContent; }) : [node.textContent];
    return parts.map(function (t) { return t.replace(/[ \t]*\n\s*/g, '\n').trim(); }).filter(Boolean).join('\n\n');
  }
  function liveRefresh() {
    if (!CFG.live || !CFG.shopDomain) return;
    var base = 'https://judge.me/reviews/all_reviews_js_based?url=' + CFG.shopDomain + '&shop_domain=' + CFG.shopDomain + '&platform=shopify&page=';
    var pages = [1, 2];
    var before = reviews.length;
    Promise.all(pages.map(function (p) { return fetch(base + p).then(function (r) { return r.json(); }).catch(function () { return null; }); }))
      .then(function (res) {
        res.forEach(function (d) {
          if (!d || !d.html) return;
          var doc = new DOMParser().parseFromString('<div>' + d.html + '</div>', 'text/html');
          doc.querySelectorAll('.jdgm-rev').forEach(function (el) {
            var id = el.getAttribute('data-review-id');
            if (!id || byId[id]) return;
            var q = function (s) { var n = el.querySelector(s); return n ? n.textContent.trim() : ''; };
            var a = el.querySelector('.jdgm-rev__prod-link');
            var href = a ? a.getAttribute('href') || '' : '';
            var body = paras(el.querySelector('.jdgm-rev__body'));
            var ts = el.querySelector('.jdgm-rev__timestamp');
            var row = [];
            row[F.id] = id;
            row[F.rating] = +(el.querySelector('[data-score]') || { getAttribute: function () { return 5; } }).getAttribute('data-score');
            row[F.date] = ts ? (ts.getAttribute('data-content') || '').slice(0, 10) : '';
            row[F.handle] = (href.match(/\/products\/([^/?#]+)/) || [])[1] || '';
            row[F.product] = a ? a.textContent.trim() : '';
            row[F.author] = q('.jdgm-rev__author');
            row[F.verified] = el.getAttribute('data-verified-buyer') === 'true' ? 1 : 0;
            row[F.title] = q('.jdgm-rev__title');
            row[F.body] = body;
            row[F.pics] = Array.prototype.map.call(el.querySelectorAll('.jdgm-rev__pic-link'), function (l) { return (l.getAttribute('href') || '').split('?')[0]; }).filter(Boolean);
            row[F.vids] = Array.prototype.map.call(el.querySelectorAll('video source, video[src]'), function (v) { return v.getAttribute('src'); }).filter(Boolean);
            row[F.location] = q('.jdgm-rev__location');
            if (F.reply != null) row[F.reply] = paras(el.querySelector('.jdgm-rev__reply-content'));
            addRow(row);
          });
        });
        if (reviews.length !== before) { renderHero(); renderPatterns(); renderAll(true); }
      });
  }

  readUrl();
  stickyOffset();
  window.addEventListener('resize', stickyOffset, { passive: true });
  renderHero();
  renderPatterns();
  renderAll(true);
  liveRefresh();
  }
  init();
  // Theme editor re-renders the section on every setting change
  document.addEventListener('shopify:section:load', init);
})();
